import { render, staticRenderFns } from "./ParentCategoryCreate.vue?vue&type=template&id=cd133a98&scoped=true&"
import script from "./ParentCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./ParentCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd133a98",
  null
  
)

export default component.exports